import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Heart, MapPin, Thermometer, Wind, Droplets, Sun, Moon, Star, Clock, Calendar, 
  Target, Zap, Users, Play, MessageCircle, Gift, Coffee, Camera, Settings, 
  User, LogOut, Globe, Mail, Smile, TrendingUp, Compass, Share2, Headphones,
  Sparkles, Crown, Diamond, Palette, Music, BookOpen, Dumbbell,
  ChevronRight, Plus, Bell, Search, Filter, MoreHorizontal, X, ChevronDown,
  Home, Briefcase, Activity, PieChart, BarChart2, ShoppingBag, CreditCard,
  Wallet2,
  CoffeeIcon
} from 'lucide-react';
import emailjs from 'emailjs-com';
import { motion  } from 'framer-motion';
import Loading from './Loading'; 
import Avatar from './Avatar';
import ProfilePopup from './ProfilePopup';
import Buy from './Buy';
import DailyJourney from './DailyJourney';
import FoodPlatform from './Food';
import FinancialHub from './Finance';
import SocialHub from './SocialHub';


const AbiLoop = () => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [darkMode, setDarkMode] = useState(true);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [chatOpen, setChatOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [user, setUser] = useState(null);
  const [floatingMenuOpen, setFloatingMenuOpen] = useState(false);
  const [currentMood, setCurrentMood] = useState('😊');
  const [activeTab, setActiveTab] = useState('dashboard');
  const navigate = useNavigate();
  const [quickActions] = useState([
    { icon: Coffee, label: 'Order Coffee', color: 'from-blue-600 to-emerald-600' },
    { icon: Dumbbell, label: 'Book Gym', color: 'from-red-600 to-pink-600' },
    { icon: Music, label: 'Play Playlist', color: 'from-purple-600 to-indigo-600' },
    { icon: Camera, label: 'Capture Moment', color: 'from-blue-600 to-cyan-600' },
    { icon: BookOpen, label: 'Continue Reading', color: 'from-green-600 to-emerald-600' },
    { icon: Gift, label: 'Send Gift', color: 'from-pink-600 to-rose-600' }
  ]);
  const [showProfilePopup, setShowProfilePopup] = useState(false);

  const [socialConnections] = useState([
    { 
      name: 'Marcus Chen', 
      activity: 'Birthday celebration', 
      status: 'online', 
      mutual: 12, 
      similarity: 95,
      mood: '🥳',
      score: 92,
      image: 'https://randomuser.me/api/portraits/men/32.jpg'
    },
    { 
      name: 'Sofia Rodriguez', 
      activity: 'Just shared a travel tip', 
      status: 'online', 
      mutual: 8, 
      similarity: 88,
      mood: '😊',
      score: 87,
      image: 'https://randomuser.me/api/portraits/women/44.jpg'
    }
  ]);
  const [isLoading, setIsLoading] = useState(true);
  const [showCalendar, setShowCalendar] = useState(false);
  const [moodHistory, setMoodHistory] = useState([]);
  const sidebarRef = useRef(null);

   const quickActionItems = [
      { icon: Coffee, label: 'Order Coffee', color: 'from-blue-600 to-emerald-600' },
      { icon: Dumbbell, label: 'Book Gym', color: 'from-red-600 to-pink-600' },
      { icon: Music, label: 'Play Playlist', color: 'from-purple-600 to-indigo-600' },
      { icon: Camera, label: 'Capture Moment', color: 'from-blue-600 to-cyan-600' },
      { icon: BookOpen, label: 'Continue Reading', color: 'from-green-600 to-emerald-600' },
      { icon: Gift, label: 'Send Gift', color: 'from-pink-600 to-rose-600' }
    ];

  // Color themes
  const themeColors = {
    dark: {
      primary: 'from-slate-900 via-blue-900 to-emerald-900',
      secondary: 'from-gray-900 via-black to-gray-800',
      accent: 'from-blue-600 to-emerald-600',
      glass: 'bg-black/30 border-blue-500/20',
      text: 'text-blue-100',
      textSecondary: 'text-blue-200/70',
      card: 'bg-slate-800/50',
      highlight: 'bg-blue-900/40'
    },
    light: {
      primary: 'from-blue-50 via-emerald-50 to-white',
      secondary: 'from-gray-50 via-white to-gray-100',
      accent: 'from-blue-500 to-emerald-500',
      glass: 'bg-white/50 border-blue-600/20',
      text: 'text-slate-900',
      textSecondary: 'text-slate-700',
      card: 'bg-white/70',
      highlight: 'bg-blue-100/70'
    }
  };

  const currentTheme = darkMode ? themeColors.dark : themeColors.light;

  // Sample data
  const weather = {
    temp: 24,
    condition: 'Partly Cloudy',
    humidity: 68,
    windSpeed: 12,
    airQuality: 'Excellent',
    pollenCount: 'Low',
    uvIndex: 6,
    sunrise: '06:30',
    sunset: '18:45'
  };

  const premiumAds = [
    { 
      title: 'Exclusive Collection', 
      subtitle: 'Luxury Timepieces', 
      image: 'https://images.unsplash.com/photo-1523170335258-f5ed11844a49?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1480&q=80', 
      color: 'from-slate-800 via-blue-900 to-emerald-900',
      cta: 'Discover Elegance'
    },
    { 
      title: 'Private Jet Experiences', 
      subtitle: 'Fly in Ultimate Luxury', 
      image: 'https://images.unsplash.com/photo-1556388158-158ea5ccacbd?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80', 
      color: 'from-gray-800 via-black to-gray-900',
      cta: 'Book Now'
    }
  ];

  const journeyData = {
    morningRitual: { completed: true, streak: 12, activity: 'Meditation & Yoga' },
    workFocus: { completed: false, progress: '3/5 tasks', activity: 'Deep Work Sessions' },
    wellness: { completed: true, streak: 8, activity: 'Hydration Goal' },
    evening: { completed: false, progress: 'Planned', activity: 'Reading & Reflection' }
  };

  const moodOptions = ['😊', '😎', '🥳', '😌', '🤔', '💪', '🔥', '✨'];

  // Effects
  useEffect(() => {
      // Fetch user data on component mount
      const fetchUserData = async () => {
        try {
          const response = await fetch('/api/al/auth/me', {
            method: 'GET',
            credentials: 'include' 
          });
  
          if (!response.ok) {
            throw new Error('Unauthorized');
          }
  
          const userData = await response.json();
          //console.log("userData", userData)
          setUser(userData);
          //setIsLoading(false);
        } catch (error) {
          //console.error('Failed to fetch user:', error);
          // Redirect to login if not authenticated
          navigate('/AbiAuth');
        }
      };
  
      fetchUserData();
  
      // Time and other effects
      const timer = setInterval(() => setCurrentTime(new Date()), 1000);
      return () => clearInterval(timer);
    }, [navigate]);


     useEffect(() => {
        // Simulate loading time (e.g., 3 seconds)
        const timer = setTimeout(() => setIsLoading(false), 3000);
        return () => clearTimeout(timer);
      }, []);

  useEffect(() => {
    const slideTimer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % premiumAds.length);
    }, 6000);
    return () => clearInterval(slideTimer);
  }, []);

    

  const handleThemeToggle = () => {
    setIsTransitioning(true);
    setTimeout(() => {
      setDarkMode(!darkMode);
      setTimeout(() => setIsTransitioning(false), 800);
    }, 200);
  };

  const getTimeBasedGreeting = () => {
    const hour = currentTime.getHours();
    if (hour < 12) return 'Good morning';
    if (hour < 17) return 'Good afternoon';
    return 'Good evening';
  };

  const formatTime = (date) => {
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
  };

  const handleMoodSelect = (mood) => {
    setCurrentMood(mood);
    setMoodHistory(prev => [
      ...prev,
      {
        date: new Date(),
        mood: mood,
        score: Math.floor(Math.random() * 20) + 80
      }
    ]);
  };

  
    const generateCalendar = () => {
      const year = currentTime.getFullYear();
      const month = currentTime.getMonth();
      const firstDay = new Date(year, month, 1);
      const lastDay = new Date(year, month + 1, 0);
      
      const days = [];
      for (let i = 0; i < firstDay.getDay(); i++) {
        days.push(null);
      }
      
      for (let i = 1; i <= lastDay.getDate(); i++) {
        days.push(i);
      }
      
      return (
        <div className={`absolute top-12 left-0 w-64 p-4 rounded-lg shadow-2xl backdrop-blur-md ${currentTheme.glass} border z-50`}>
          <div className="flex justify-between items-center mb-4">
            <h4 className={`text-sm font-medium ${currentTheme.text}`}>
              {currentTime.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}
            </h4>
            <div className="flex space-x-2">
              <button className={`p-1 rounded ${currentTheme.highlight}`}>
                <ChevronDown className="w-4 h-4 rotate-90" />
              </button>
              <button className={`p-1 rounded ${currentTheme.highlight}`}>
                <ChevronDown className="w-4 h-4 -rotate-90" />
              </button>
            </div>
          </div>
          
          <div className="grid grid-cols-7 gap-1 text-center">
            {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map(day => (
              <div key={day} className={`text-xs ${currentTheme.textSecondary}`}>{day}</div>
            ))}
            
            {days.map((day, index) => (
              <div 
                key={index} 
                className={`p-1 rounded-full text-sm ${
                  day === currentTime.getDate() 
                    ? 'bg-blue-500 text-white' 
                    : day 
                      ? currentTheme.textSecondary 
                      : 'opacity-0'
                }`}
              >
                {day}
              </div>
            ))}
          </div>
        </div>
      );
    };


// Add new state variables
  const [showMoodPicker, setShowMoodPicker] = useState(false);
  const [currentNewsCategory, setCurrentNewsCategory] = useState('general');
  const [personalizedContent, setPersonalizedContent] = useState([]);

  // Sample news data by category
  const newsData = {
    general: [
      { title: "Global Summit on Climate Change Concludes", source: "World News", time: "2h ago" },
      { title: "Tech Giant Unveils Revolutionary AI Assistant", source: "Tech Daily", time: "4h ago" }
    ],
    sports: [
      { title: "National Team Advances to Finals", source: "Sports Network", time: "1h ago" },
      { title: "Star Player Sets New Scoring Record", source: "Athlete's Journal", time: "5h ago" }
    ],
    politics: [
      { title: "New Legislation Passed on Digital Privacy", source: "Policy Review", time: "3h ago" },
      { title: "Diplomatic Talks Between Neighboring Countries", source: "Global Affairs", time: "6h ago" }
    ],
    entertainment: [
      { title: "Award-Winning Film Director Announces New Project", source: "Cinema Today", time: "2h ago" },
      { title: "Music Festival Breaks Attendance Records", source: "Culture Beat", time: "8h ago" }
    ]
  };

  // Historical events for current date
  const historicalEvents = [
    { year: 1962, event: "Independence Day in Uganda" },
    { year: 1991, event: "First website goes live at CERN" },
    { year: 2008, event: "Bitcoin whitepaper published" }
  ];

  // Personalized content based on user interests
  useEffect(() => {
    // This would normally come from user preferences or API
    const content = [
      { 
        type: "podcast", 
        title: "The Future of Digital Luxury", 
        author: "Tech Visionaries", 
        icon: <Headphones className="w-5 h-5" />
      },
      { 
        type: "article", 
        title: "Mastering the Art of Productivity", 
        source: "Mind & Work", 
        icon: <BookOpen className="w-5 h-5" />
      },
      { 
        type: "event", 
        title: "Luxury Tech Expo 2023", 
        date: "Next Week", 
        icon: <Calendar className="w-5 h-5" />
      }
    ];
    setPersonalizedContent(content);
  }, []);

  // Tab contents
const renderBuy = () => {
    navigate('/AbiBuy');
}





const sendEmail = () => {
  if (!message.trim()) return;

  setSending(true);

  const templateParams = {
    message: message,
    subject: "Abiloop - Live chat message",
    user_name: user?.first_name || 'Guest',
    user_email:  user?.first_name || 'noreplay@layerff.tech',
  };

  emailjs
    .send(
       'service_vk6eiym',     // e.g. service_xxxxx
        'template_4pwjk5r',    // e.g. template_yyyyy
      templateParams,
      'P9DB1kB37lbSYsdbr'        
    )
    .then((response) => {
      alert('SUCCESS!', 'Your message has been sent successfully to the Admin.');
      setMessage('');
    })
    .catch((err) => {
      alert('FAILED...', err);
    })
    .finally(() => setSending(false));
};



const renderDashboard = () => {
  // Improved mood picker component
  const renderMoodPicker = () => (
    <motion.div 
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.2 }}
      className={`absolute right-0 top-full mt-2 p-4 rounded-xl shadow-xl ${currentTheme.card} z-50 w-72`}
    >
      <div className="flex justify-between items-center mb-3">
        <h4 className={`text-sm font-medium ${currentTheme.text}`}>Track Your Mood</h4>
        <button 
          onClick={() => setShowMoodPicker(false)}
          className={`p-1 rounded-full hover:bg-white/10 ${currentTheme.textSecondary}`}
        >
          <X className="w-4 h-4" />
        </button>
      </div>
      
      <div className="grid grid-cols-5 gap-2 mb-4">
        {moodOptions.map((mood, index) => (
          <button
            key={index}
            onClick={() => {
              handleMoodSelect(mood);
              setShowMoodPicker(false);
            }}
            className={`text-2xl p-2 rounded-lg transition-all duration-200 ${
              currentMood === mood 
                ? 'bg-blue-500/20 scale-110' 
                : 'hover:bg-white/10 hover:scale-105'
            }`}
          >
            {mood}
          </button>
        ))}
      </div>
      
      <div>
        <h5 className={`text-xs font-medium mb-2 ${currentTheme.text}`}>Mood History</h5>
        <div className="flex space-x-2 overflow-x-auto pb-2">
          {moodHistory.slice(-7).map((day, index) => (
            <div 
              key={index} 
              className={`text-center flex-shrink-0 ${currentTheme.textSecondary}`}
              title={`${day.mood} on ${day.date.toLocaleDateString()}`}
            >
              <div className="text-lg">{day.mood}</div>
              <div 
                className={`h-1 mt-1 rounded-full ${
                  day.score > 80 ? 'bg-green-400' :
                  day.score > 60 ? 'bg-blue-400' : 'bg-yellow-400'
                }`}
                style={{ width: `${day.score / 1.2}%` }}
              />
            </div>
          ))}
        </div>
      </div>
    </motion.div>
  );

  // News category selector
  const renderNewsCategorySelector = () => (
    <div className={`flex space-x-2 p-1 rounded-lg ${darkMode ? 'bg-slate-800/50' : 'bg-blue-100/50'} mb-4`}>
      {['general', 'sports', 'politics', 'entertainment'].map(category => (
        <button
          key={category}
          onClick={() => setCurrentNewsCategory(category)}
          className={`px-3 py-1 text-xs rounded-md transition-all ${
            currentNewsCategory === category
              ? `${darkMode ? 'bg-blue-900/50 text-white' : 'bg-white text-blue-800'}`
              : `${darkMode ? 'text-blue-200/70 hover:bg-slate-700/50' : 'text-blue-800/70 hover:bg-blue-100'}`
          }`}
        >
          {category.charAt(0).toUpperCase() + category.slice(1)}
        </button>
      ))}
    </div>
  );

  return (
    <div className="space-y-8">
      {/* Main Content Area */}
      <div className="mb-12">
        <div className="flex items-center justify-between mb-8">
          <div>
            <div className="flex items-center space-x-4 mb-4">
              <h1 className={`text-6xl font-thin ${currentTheme.text}`}>
                {getTimeBasedGreeting()}, 
                <span className={`font-light bg-gradient-to-r ${currentTheme.accent} bg-clip-text text-transparent ml-3`}>
                  {user?.first_name || '' }
                </span>
              </h1>
            </div>
            <div className="flex items-center space-x-8 mt-6">
              <div className={`flex items-center space-x-3 ${currentTheme.textSecondary}`}>
                <Clock className="w-6 h-6" />
                <span className="text-2xl font-light tracking-wider">{formatTime(currentTime)}</span>
              </div>
              <div className={`flex items-center space-x-3 ${currentTheme.textSecondary} relative`}>
                <Calendar 
                  className="w-6 h-6 cursor-pointer" 
                  onClick={() => setShowCalendar(!showCalendar)}
                />
                <span className="font-light text-lg">
                  {currentTime.toLocaleDateString('en-US', { 
                    weekday: 'long', 
                    month: 'long', 
                    day: 'numeric' 
                  })}
                </span>
                {showCalendar && (
                  <div className={`absolute top-12 left-0 w-64 p-4 rounded-lg shadow-2xl backdrop-blur-md ${currentTheme.glass} border z-50`}>
                    <div className="flex justify-between items-center mb-4">
                      <h4 className={`text-sm font-medium ${currentTheme.text}`}>
                        {currentTime.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}
                      </h4>
                    </div>
                    
                    <div className="mb-4">
                      <h5 className={`text-xs font-medium mb-2 ${currentTheme.text}`}>Today in History</h5>
                      <ul className={`text-xs space-y-1 ${currentTheme.textSecondary}`}>
                        {historicalEvents.map((event, i) => (
                          <li key={i} className="flex">
                            <span className="font-medium mr-2">{event.year}:</span>
                            <span>{event.event}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                    
                    <div className="grid grid-cols-7 gap-1 text-center">
                      {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map(day => (
                        <div key={day} className={`text-xs ${currentTheme.textSecondary}`}>{day}</div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
              <div className="flex items-center space-x-2">
                <Sparkles className={`w-5 h-5 ${darkMode ? 'text-blue-400' : 'text-blue-600'}`} />
                <span className={`text-sm ${currentTheme.textSecondary}`}>Premium Member</span>
              </div>
            </div>
          </div>

          {/* Enhanced Mood Tracker */}
          <div className="flex items-center space-x-4 relative">
            <div className={`flex items-center space-x-2 ${currentTheme.textSecondary}`}>
              <span className="text-sm">Mood:</span>
              <div className="flex items-center space-x-1">
                <button
                  onClick={() => setShowMoodPicker(!showMoodPicker)}
                  className="text-2xl hover:scale-125 transition-all duration-300"
                >
                  {currentMood}
                </button>
                <ChevronDown className="w-4 h-4" />
              </div>
            </div>
            {showMoodPicker && renderMoodPicker()}
          </div>
        </div>

        {/* Enhanced Weather Section */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
          <div className={`p-6 rounded-3xl backdrop-blur-md ${currentTheme.glass} shadow-2xl border hover:scale-105 transition-all duration-300`}>
            <div className="flex items-center justify-between">
              <div>
                <div className="flex items-center space-x-2 mb-3">
                  <MapPin className={`w-5 h-5 ${darkMode ? 'text-blue-400' : 'text-blue-600'}`} />
                  <span className={`font-light ${currentTheme.textSecondary}`}>Kampala, Uganda</span>
                </div>
                <div className={`text-4xl font-thin ${currentTheme.text} mb-1`}>{weather.temp}°C</div>
                <div className={`text-sm ${currentTheme.textSecondary}`}>{weather.condition}</div>
              </div>
              <Sun className="w-14 h-14 text-blue-400" />
            </div>
          </div>

          {/* Current News Section */}
          <div className={`p-6 rounded-3xl backdrop-blur-md ${currentTheme.glass} shadow-2xl border hover:scale-105 transition-all duration-300 col-span-2`}>
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center space-x-3">
                <Globe className={`w-6 h-6 ${darkMode ? 'text-blue-400' : 'text-blue-600'}`} />
                <h3 className={`text-xl font-light ${currentTheme.text}`}>Today's Headlines</h3>
              </div>
            </div>
            
            {renderNewsCategorySelector()}
            
            <div className="space-y-4">
              {newsData[currentNewsCategory].map((item, index) => (
                <div key={index} className={`p-4 rounded-xl ${darkMode ? 'bg-slate-800/30' : 'bg-blue-100/30'} hover:bg-white/10 transition-all`}>
                  <div className="flex justify-between items-start">
                    <h4 className={`font-medium ${currentTheme.text}`}>{item.title}</h4>
                    <span className={`text-xs ${currentTheme.textSecondary}`}>{item.time}</span>
                  </div>
                  <p className={`text-xs mt-1 ${currentTheme.textSecondary}`}>{item.source}</p>
                </div>
              ))}
            </div>
          </div>

          <div className={`p-6 rounded-3xl backdrop-blur-md ${currentTheme.glass} shadow-2xl border hover:scale-105 transition-all duration-300`}>
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-2">
                  <Wind className="w-4 h-4 text-blue-400" />
                  <span className={`text-sm ${currentTheme.textSecondary}`}>Wind</span>
                </div>
                <span className={`font-light ${currentTheme.text}`}>{weather.windSpeed} km/h</span>
              </div>
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-2">
                  <Droplets className="w-4 h-4 text-blue-400" />
                  <span className={`text-sm ${currentTheme.textSecondary}`}>Humidity</span>
                </div>
                <span className={`font-light ${currentTheme.text}`}>{weather.humidity}%</span>
              </div>
            </div>
          </div>
        </div>
      </div>

           {/* Premium Ads Carousel */}
              <div className="mb-12">
                <div className="relative h-80 rounded-3xl overflow-hidden shadow-2xl">
                  <div 
                    className={`absolute inset-0 bg-gradient-to-r ${premiumAds[currentSlide].color} transition-all duration-1000`}
                  >
                    <div className="absolute inset-0 bg-black/30" />
                    <img 
                      src={premiumAds[currentSlide].image} 
                      alt="Premium ad"
                      className="absolute inset-0 w-full h-full object-cover opacity-70"
                    />
                    <div className="relative h-full flex items-center justify-between p-10">
                      <div className="text-white">
                        <h3 className="text-4xl font-thin mb-3">{premiumAds[currentSlide].title}</h3>
                        <p className="text-2xl opacity-90 font-light mb-6">{premiumAds[currentSlide].subtitle}</p>
                        <button className="px-10 py-4 bg-white/20 backdrop-blur-md rounded-full text-white font-light hover:bg-white/30 transition-all duration-300 text-lg">
                          {premiumAds[currentSlide].cta}
                        </button>
                      </div>
                      <div className="text-white/20 text-9xl font-thin">
                        {String(currentSlide + 1).padStart(2, '0')}
                      </div>
                    </div>
                  </div>
                  <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-3">
                    {premiumAds.map((_, index) => (
                      <button
                        key={index}
                        className={`w-4 h-4 rounded-full transition-all duration-300 ${
                          index === currentSlide ? 'bg-white scale-125' : 'bg-white/50'
                        }`}
                        onClick={() => setCurrentSlide(index)}
                      />
                    ))}
                  </div>
                </div>
                </div>

      {/* Personalized Content Section */}
      <div className={`p-8 rounded-3xl backdrop-blur-md ${currentTheme.glass} shadow-2xl border mb-12`}>
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center space-x-3">
            <User className={`w-7 h-7 ${darkMode ? 'text-blue-400' : 'text-blue-600'}`} />
            <h3 className={`text-2xl font-light ${currentTheme.text}`}>For You</h3>
          </div>
          <div className={`px-4 py-2 rounded-full ${currentTheme.glass} border`}>
            <span className={`text-sm ${currentTheme.textSecondary}`}>Personalized</span>
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {personalizedContent.map((item, index) => (
            <div key={index} className={`p-6 rounded-2xl ${darkMode ? 'bg-slate-800/30' : 'bg-white/50'} hover:bg-white/10 transition-all cursor-pointer`}>
              <div className="flex items-center space-x-3 mb-4">
                <div className={`p-2 rounded-lg ${darkMode ? 'bg-blue-900/30' : 'bg-blue-100/70'}`}>
                  {item.icon}
                </div>
                <span className={`text-sm font-medium ${currentTheme.textSecondary}`}>
                  {item.type.charAt(0).toUpperCase() + item.type.slice(1)}
                </span>
              </div>
              <h4 className={`font-medium mb-2 ${currentTheme.text}`}>{item.title}</h4>
              <p className={`text-xs ${currentTheme.textSecondary}`}>
                {item.author || item.source || item.date}
              </p>
            </div>
          ))}
        </div>
      </div>

    </div>
  );
};

  const renderJourney = () => (
    <div className={`p-8 rounded-3xl backdrop-blur-md ${currentTheme.glass} shadow-2xl border`}>
      <div className="flex items-center justify-between mb-8">
        <div className="flex items-center space-x-3">
          <Compass className={`w-7 h-7 ${darkMode ? 'text-blue-400' : 'text-blue-600'}`} />
          <h3 className={`text-2xl font-light ${currentTheme.text}`}>Today's Journey</h3>
        </div>
        <div className={`px-4 py-2 rounded-full ${currentTheme.glass} border`}>
          <span className={`text-sm ${currentTheme.textSecondary}`}>78% Complete</span>
        </div>
      </div>
      
      <div className="space-y-6">
        {Object.entries(journeyData).map(([key, data]) => (
          <div key={key} className="flex items-center justify-between p-4 rounded-2xl bg-white/5 hover:bg-white/10 transition-all duration-300">
            <div className="flex items-center space-x-4">
              <div className={`w-4 h-4 rounded-full ${data.completed ? 'bg-blue-400' : 'bg-gray-500'} animate-pulse`} />
              <div>
                <div className={`font-medium ${currentTheme.text} ${data.completed ? 'line-through opacity-70' : ''}`}>
                  {data.activity}
                </div>
                {data.streak && (
                  <div className={`text-sm ${currentTheme.textSecondary}`}>
                    🔥 {data.streak} day streak
                  </div>
                )}
                {data.progress && (
                  <div className={`text-sm ${currentTheme.textSecondary}`}>
                    {data.progress}
                  </div>
                )}
              </div>
            </div>
            <ChevronRight className={`w-5 h-5 ${currentTheme.textSecondary}`} />
          </div>
        ))}
      </div>
    </div>
  );

  const renderSocial = () => (
    <div className={`p-8 rounded-3xl backdrop-blur-md ${currentTheme.glass} shadow-2xl border`}>
      <div className="flex items-center space-x-3 mb-8">
        <Users className="w-7 h-7 text-blue-400" />
        <h3 className={`text-2xl font-light ${currentTheme.text}`}>Social Hub</h3>
      </div>
      
      <div className="space-y-4">
        {socialConnections.map((person, index) => (
          <div key={index} className="flex items-center space-x-3 p-3 rounded-2xl hover:bg-white/10 transition-all duration-300 cursor-pointer group">
            <div className="relative">
              <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-blue-400">
                <img 
                  src={person.image} 
                  alt={person.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className={`absolute -bottom-1 -right-1 w-5 h-5 rounded-full flex items-center justify-center text-xs ${
                person.status === 'online' ? 'bg-green-500' : 'bg-gray-500'
              } text-white`}>
                {person.mood}
              </div>
            </div>
            <div className="flex-1">
              <div className="flex justify-between items-start">
                <div>
                  <div className={`font-medium ${currentTheme.text} text-sm`}>{person.name}</div>
                  <div className={`text-xs ${currentTheme.textSecondary}`}>{person.activity}</div>
                </div>
                <div className={`text-xs px-2 py-1 rounded-full ${
                  person.score > 90 
                    ? darkMode ? 'bg-green-900/50 text-green-300' : 'bg-green-100 text-green-800'
                    : darkMode ? 'bg-blue-900/50 text-blue-300' : 'bg-blue-100 text-blue-800'
                }`}>
                  {person.score}
                </div>
              </div>
              <div className={`text-xs mt-1 ${currentTheme.textSecondary}`}>
                {person.similarity}% similar • {person.mutual} mutual
              </div>
            </div>
          </div>
        ))}
        
        <button className={`w-full p-3 rounded-2xl border-2 border-dashed ${
          darkMode ? 'border-blue-400/30 text-blue-400' : 'border-blue-600/30 text-blue-600'
        } hover:bg-white/5 transition-all duration-300 text-sm font-light`}>
          Discover Similar People
        </button>
      </div>
    </div>
  );


  // Loading screen
  if (isLoading) {
     return <Loading user={user} />; 
  }

  return (
   <div className={`flex h-screen overflow-hidden transition-all duration-1000 ${
      isTransitioning ? 'scale-105 blur-sm' : 'scale-100 blur-0'
    } ${darkMode 
      ? 'bg-gradient-to-br from-slate-900 via-blue-900 to-emerald-900/20' 
      : 'bg-gradient-to-br from-blue-50 via-emerald-50 to-white'
    }`}>

      
      {/* Floating Particles */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        {[...Array(30)].map((_, i) => (
          <div
            key={i}
            className={`absolute rounded-full ${
              darkMode ? 'bg-blue-400' : 'bg-emerald-600'
            } opacity-20 animate-pulse`}
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              width: `${Math.random() * 6 + 2}px`,
              height: `${Math.random() * 6 + 2}px`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${Math.random() * 4 + 3}s`
            }}
          />
        ))}
      </div>

      {/* Fixed Sidebar */}
     
        <div 
      ref={sidebarRef}
      className={`w-20 h-full p-4 flex flex-col justify-between items-center backdrop-blur-md ${currentTheme.glass} border-r z-20 overflow-y-auto`}
    >
        <div className="flex flex-col items-center space-y-6">
          {/* Top Avatar */}
          <div className="mt-4">
            <div className={`w-12 h-12 rounded-full bg-gradient-to-r ${currentTheme.accent} flex items-center justify-center shadow-lg`}>
              <span className="text-xl font-light text-white">A</span>
            </div>
          </div>
        
        <button 
          className={`p-3 rounded-xl ${activeTab === 'dashboard' ? currentTheme.highlight : ''} transition-all duration-300`}
          onClick={() => setActiveTab('dashboard')}
          title="Dashboard"
        >
          <Home className={`w-6 h-6 ${darkMode ? 'text-blue-400' : 'text-blue-600'}`} />
        </button>
        
        <button 
          className={`p-3 rounded-xl ${activeTab === 'journey' ? currentTheme.highlight : ''} transition-all duration-300`}
          onClick={() => setActiveTab('journey')}
          title="Journey"
        >
          <Compass className={`w-6 h-6 ${darkMode ? 'text-blue-400' : 'text-blue-600'}`} />
        </button>
        
        <button 
          className={`p-3 rounded-xl ${activeTab === 'social' ? currentTheme.highlight : ''} transition-all duration-300`}
          onClick={() => setActiveTab('social')}
          title="Social"
        >
          <Users className={`w-6 h-6 ${darkMode ? 'text-blue-400' : 'text-blue-600'}`} />
        </button>

        <button 
          className={`p-3 rounded-xl ${activeTab === 'fastFood' ? currentTheme.highlight : ''} transition-all duration-300`}
          onClick={() => setActiveTab('fastFood')}
          title="fastFood"
        >
          <CoffeeIcon className={`w-6 h-6 ${darkMode ? 'text-blue-400' : 'text-blue-600'}`} />
        </button>
        
        
        <button 
          className={`p-3 rounded-xl ${activeTab === 'finance' ? currentTheme.highlight : ''} transition-all duration-300`}
          onClick={() => setActiveTab('finance')}
          title="Finance"
        >
          <CreditCard className={`w-6 h-6 ${darkMode ? 'text-blue-400' : 'text-blue-600'}`} />
        </button>

         <button 
          className={`p-3 rounded-xl ${activeTab === 'buy' ? currentTheme.highlight : ''} transition-all duration-300`}
          onClick={() => setActiveTab('buy')}
          title="Buy"
        >
          <Wallet2 className={`w-6 h-6 ${darkMode ? 'text-blue-400' : 'text-blue-600'}`} />
        </button>
        
        <div className="flex flex-col items-center space-y-4">
        
        <button
          onClick={handleThemeToggle}
          className={`p-3 rounded-xl transition-all duration-300 hover:bg-white/10`}
          title={darkMode ? 'Light Mode' : 'Dark Mode'}
        >
          {darkMode ? (
            <Sun className="w-6 h-6 text-blue-400" />
          ) : (
            <Moon className="w-6 h-6 text-blue-600" />
          )}
        </button>
        
        <div className="relative group">
          <div className="w-10 h-10 rounded-full overflow-hidden border-2 border-blue-400">
             <Avatar
                              firstName={user?.first_name || ''}
                              lastName={user?.last_name || ''}
                              className="w-10 h-10 text-sm"
                              onClick={() => setShowProfilePopup(true)}
                            />
          </div>
          <div className={`absolute left-full ml-2 top-1/2 transform -translate-y-1/2 p-2 rounded-lg shadow-lg ${currentTheme.card} opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap`}>
            <div className={`text-sm ${currentTheme.text}`}>{user?.first_name || '' }</div>
            <div className={`text-xs ${currentTheme.textSecondary}`}>Premium Member</div>
          </div>
        </div>
      </div>
      </div>
      </div>

       {showProfilePopup && (
                    <ProfilePopup 
                      user={{ ...user, darkMode }} 
                      onClose={() => setShowProfilePopup(false)} 
                    />
                  )}

       {/* Main Content */}
        <div className="flex-1 overflow-y-auto">
          <div className="relative z-10 pl-6 pr-6 pb-24 pt-6 max-w-7xl mx-auto">
            {/* Tab Content */}
            {activeTab === 'dashboard' && renderDashboard()}
            {activeTab === 'journey' && <DailyJourney darkMode={darkMode}/>}
            {activeTab === 'social' && <SocialHub darkMode={darkMode}/>}
            {activeTab === 'finance' && <FinancialHub darkMode={darkMode} />}
            {activeTab === 'buy' && renderBuy()}
            {activeTab === 'fastFood' && <FoodPlatform />}
            
          </div>
        </div>

      {/* Fixed Footer */}
      <div className={`fixed bottom-0 left-0 right-0 py-4 px-6 border-t ${
        darkMode ? 'border-blue-900 bg-slate-900/80' : 'border-blue-200 bg-white/80'
      } backdrop-blur-md z-10`}>
        <div className="flex flex-col md:flex-row justify-between items-center max-w-7xl mx-auto">
          <div className={`text-sm ${currentTheme.textSecondary} mb-2 md:mb-0`}>
            © 2023 ABILOOP • Premium Lifestyle Platform
          </div>
          <div className="flex space-x-6">
            <a href="#" className={`text-sm ${currentTheme.textSecondary} hover:text-blue-400 transition-colors`}>
              Terms
            </a>
            <a href="#" className={`text-sm ${currentTheme.textSecondary} hover:text-blue-400 transition-colors`}>
              Privacy
            </a>
            <a href="#" className={`text-sm ${currentTheme.textSecondary} hover:text-blue-400 transition-colors`}>
              Help
            </a>
            <a href="#" className={`text-sm ${currentTheme.textSecondary} hover:text-blue-400 transition-colors`}>
              Contact
            </a>
          </div>
        </div>
      </div>

      {/* Chat Button */}
      <button
        onClick={() => setChatOpen(!chatOpen)}
        className={`fixed bottom-8 right-8 w-16 h-16 bg-gradient-to-r ${currentTheme.accent} rounded-full shadow-2xl flex items-center justify-center hover:scale-110 transition-all duration-300 z-20`}
      >
        <MessageCircle className="w-7 h-7 text-white" />
        <div className="absolute -top-2 -right-2 w-6 h-6 bg-red-500 rounded-full flex items-center justify-center">
          <span className="text-xs text-white font-bold">3</span>
        </div>
      </button>

      {/* Chat Interface */}
      {chatOpen && (
        <div className={`fixed bottom-28 right-8 w-96 h-96 rounded-3xl backdrop-blur-md ${currentTheme.glass} shadow-2xl overflow-hidden border flex flex-col z-30`}>
          <div className={`p-4 border-b ${darkMode ? 'border-blue-500/20' : 'border-blue-600/20'} flex justify-between items-center`}>
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 rounded-full bg-gradient-to-r from-blue-500 to-emerald-500 flex items-center justify-center">
                <span className="text-white text-lg">A</span>
              </div>
              <div>
                <h4 className={`text-lg font-light ${currentTheme.text}`}>AI Concierge</h4>
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse" />
                  <span className={`text-xs ${currentTheme.textSecondary}`}>Online</span>
                </div>
              </div>
            </div>
            <button 
              onClick={() => setChatOpen(false)}
              className={`p-2 rounded-full hover:bg-white/10 transition-colors ${currentTheme.textSecondary}`}
            >
              <X className="w-5 h-5" />
            </button>
          </div>
          
          <div className="flex-1 p-4 overflow-y-auto space-y-4">
            <div className={`p-4 rounded-2xl ${darkMode ? 'bg-blue-900/20' : 'bg-blue-100/50'} max-w-xs`}>
              <p className={`text-sm ${currentTheme.textSecondary}`}>
                Welcome back, {user?.first_name || '' }! How may I assist you today?
              </p>
            </div>
            <div className={`p-4 rounded-2xl ${darkMode ? 'bg-white/10' : 'bg-gray-100'} max-w-xs ml-auto`}>
              <p className={`text-sm ${currentTheme.text}`}>
                Show me today's exclusive offers
              </p>
            </div>
            <div className={`p-4 rounded-2xl ${darkMode ? 'bg-blue-900/20' : 'bg-blue-100/50'} max-w-xs`}>
              <p className={`text-sm ${currentTheme.textSecondary}`}>
                I've curated 3 exclusive experiences for you. Which interests you most?
              </p>
            </div>
          </div>
          
          <div className={`p-4 border-t ${darkMode ? 'border-blue-500/20' : 'border-blue-600/20'}`}>
            <div className="flex space-x-3">
              <input
                type="text"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Ask me anything..."
                className={`flex-1 p-3 rounded-2xl backdrop-blur-md ${currentTheme.glass} border ${currentTheme.text} placeholder-gray-400 focus:outline-none focus:ring-2 ${
                  darkMode ? 'focus:ring-blue-500' : 'focus:ring-blue-600'
                }`}
              />
              <button 
                onClick={sendEmail}
                disabled={sending}
                className={`px-5 py-3 bg-gradient-to-r ${currentTheme.accent} rounded-2xl text-white hover:scale-105 transition-all duration-300 font-light ${
                  sending ? 'opacity-50 cursor-not-allowed' : ''
                }`}
              >
                {sending ? 'Sending...' : 'Send'}
              </button>

            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AbiLoop;
